module.exports = __webpack_public_path__ + "static/img/Desktop_WeAreABlend.b9a5188.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop/landing/2024/Desktop_WeAreABlend.svg
// module id = eCdY
// module chunks = 1